export class ListConditionsService {
    constructor(httpClient) {
      this.httpClient = httpClient
    }
  
    async handle(params) {
      return await this.httpClient.get('/v01/clientes/buscaCondicao', { params })
    }
  }
  